import UserProfile from "../../../Components/UserProfile";

const VolunteerProfile = () => {
  return (
    <div className="">
      <UserProfile />
    </div>
  );
};

export default VolunteerProfile;
